module.exports = __webpack_public_path__ + "static/media/win-loop.3483f3d7.gif";